<template>
  <div id="client-manager">
    <section class="section">
      <card-component
        class="has-table is-fullwidth"
        title="Client List"
        icon="video-input-component"
      >
        <template #headerRight>
          <router-link to="client/create">
            <b-button
              v-if="hasPermission('POST')"
              type="is-primary"
              icon-left="plus"
              size="is-small"
            >
              New Client
            </b-button>
          </router-link>
        </template>
        <fl-table
          is-paginated
          namespace="client"
          ref="table"
          title-key="name"
          :columns="clientColumns"
          :has-delete="hasPermission('DELETE')"
          :has-update="hasPermission('PUT')"
          :service="service"
        >
        </fl-table>
      </card-component>
    </section>
  </div>
</template>

<script>
import { read as readClient, del as deleteClient } from '@/api/client'
import FlTable from '@/components/table/FlTable'

export default {
  name: 'ReadClient',
  components: { FlTable },
  data() {
    const clientColumns = [
      {
        label: 'Name',
        key: 'name'
      },
      {
        label: 'Projects',
        key: 'project',
        content: row => row.projects.length
      }
    ]

    return {
      clientColumns,
      service: {
        read: readClient,
        delete: deleteClient
      }
    }
  },
  methods: {
    hasPermission(method) {
      return this.$store.getters['auth/hasPermission']('DRIVER', method)
    },
    getExportClientURL(client) {
      return `${process.env.VUE_APP_BASE_URL}/client/export/${client.id}`
    }
  }
}
</script>
